module.exports = "<div class=\"date-component\" style=\"margin: -25px 0 5px 15px;\">\n  <div layout=\"row\" layout-align=\"start center\">\n    <span>{{$ctrl.startDate | amDateFormat : 'YYYY年MM月'}} ~ {{$ctrl.endDate | amDateFormat : 'YYYY年MM月'}}</span>\n  </div>\n</div>\n<md-content>\n  <chart value=\"$ctrl.chartConfig\" style=\"margin: 0 15px\"></chart>\n</md-content>\n"


//////////////////
// WEBPACK FOOTER
// ./public/dev/app/compare-graph/demand/yearly/compare-graph-yearly.html
// module id = 889
// module chunks = 0